module.exports = __webpack_public_path__ + "market/static/img/successCupImg.1bfee5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ques/successCupImg.png
// module id = 9z09
// module chunks = 1